<script lang="ts">
	import type { PartnerBoxMapData } from '@viamichelin/business';
	import type { ClassValue } from 'svelte/elements';
	import ObfuscatedLink from '$lib/components/atoms/obfuscatedLink/ObfuscatedLink.svelte';
	import { onMount } from 'svelte';

	interface Props {
		data?: PartnerBoxMapData;
		shortMessage?: string;
		onclick: (e: MouseEvent) => void;
		onMount?: () => void;
		class?: ClassValue;
	}

	const {
		data,
		shortMessage,
		onclick,
		onMount: emitOnMount,
		class: classes,
	}: Props = $props();

	const { message, url: href, img, type } = data || {};

	onMount(() => {
		emitOnMount?.();
	});
</script>

<ObfuscatedLink
	{href}
	{onclick}
	dataTestId={`ad-map-itinerary-result-${data?.type}`}
	target="_blank"
	class={[classes, 'text-sm px-2 cursor-pointer rd-1 h-9 inline-flex items-center border-0.5 border-solid border-coloredneutral-softest bg-neutral-weakest hover:bg-neutral-weak active:bg-neutral-soft text-coloredneutral gap-x-2 shadow-smooth-bottom-3']}
>
	<img src={img} alt={`Logo ${type}`} class="size-5" />
	<span class="whitespace-nowrap">{shortMessage || message}</span>
</ObfuscatedLink>
